/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgEqual = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 24 24"
    data-name="SvgEqual"
    {...props}
  >
    {props.children}
    <path stroke="#000" strokeLinecap="round" strokeLinejoin="round" d="M5 9h14M5 15h14" />
  </svg>
)
